import isBaselineInIframe from '../../../utils/isBaselineInIframe';
import remove_id_from_list from '../../../utils/remove_id_from_list';
import { setSelectedImageIds, setTemporaryImageIds } from '../../slices/imagesSlice';

export function handle_image(id) {
  return async (dispatch) => {
    /**
     * check whether baseline is in an iframe to
     * determine which flow to take for handling
     * columbia s3
     */
    if (isBaselineInIframe()) {
      dispatch(update_temp_image_id_list(id));
    } else {
      dispatch(update_image_id_list(id));
    }
  };
}

/**
 * if the selected ids already includes the
 * image that was last selected, then remove
 * it from the list. otherwise append the id
 * to the list.
 */
export function update_image_id_list(id) {
  return async (dispatch, getState) => {
    const { selectedImageIds } = getState().images;
    let id_list = [...selectedImageIds];

    if (id_list.includes(id)) {
      id_list = remove_id_from_list(id, id_list);
    } else {
      id_list = [...id_list, id];
    }
    dispatch(setSelectedImageIds(id_list));
  };
}

/**
 * if the selected ids already includes the
 * image that was last selected, then remove
 * it from the list. otherwise append the id
 * to the list.
 */
export function update_temp_image_id_list(id) {
  return async (dispatch, getState) => {
    const { temporaryImageIds } = getState().images;
    let id_list = [...temporaryImageIds];

    if (id_list.includes(id)) {
      id_list = remove_id_from_list(id, id_list);
    } else {
      id_list = [...id_list, id];
    }
    dispatch(setTemporaryImageIds(id_list ?? []));
  };
}
